export default "__VITE_ASSET__DzV$GC$Z__"